import { Routes, Route } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ErrorPage from '@/views/pages/404Page';
import { GuardedPageRoute } from '../routeGuards';
import {
  CreateAccountPage,
  CustomerDiscountPage,
  CustomerDiscountTierPage,
  EditAccountPage,
  ManageAccountsPage,
  ManageCustomerDetailPage,
  ManageCustomersPage,
} from '../lazyPages';

export const BusinessManageUserRoutes = () => {
  const { t } = useTranslation();

  return (
    <Routes>
      <Route
        index
        element={
          <GuardedPageRoute pageName={t('SIDEBAR.MANAGE_ACCOUNTS')}>
            <ManageAccountsPage />
          </GuardedPageRoute>
        }
      />
      <Route
        path="create"
        element={
          <GuardedPageRoute pageName={t('CREATE_USER')} action="create">
            <CreateAccountPage />
          </GuardedPageRoute>
        }
      />
      <Route
        path="edit/:id"
        element={
          <GuardedPageRoute pageName={t('EDIT_USER')} action="update">
            <EditAccountPage />
          </GuardedPageRoute>
        }
      />
      <Route path="*" element={<ErrorPage />} />
    </Routes>
  );
};

export const BusinessManageCustomersRoute = () => {
  const { t } = useTranslation();
  return (
    <Routes>
      <Route
        index
        element={
          <GuardedPageRoute pageName={t('BUSINESS_SIDEBAR.MANAGE_CUSTOMERS')}>
            <ManageCustomersPage />
          </GuardedPageRoute>
        }
      />
      <Route
        path="detail/:id"
        element={
          <GuardedPageRoute pageName={t('BUSINESS_SIDEBAR.MANAGE_CUSTOMERS')}>
            <ManageCustomerDetailPage />
          </GuardedPageRoute>
        }
      />
      <Route path="*" element={<ErrorPage />} />
    </Routes>
  );
};

export const BusinessCustomerDiscountRoute = () => {
  const { t } = useTranslation();
  return (
    <Routes>
      <Route
        index
        element={
          <GuardedPageRoute
            pageName={t('BUSINESS_SIDEBAR.CUSTOMER_DISCOUNTS.TIER_LIST')}
          >
            <CustomerDiscountTierPage />
          </GuardedPageRoute>
        }
      />
      <Route
        path="discount-configuration"
        element={
          <GuardedPageRoute
            pageName={t(
              'BUSINESS_SIDEBAR.CUSTOMER_DISCOUNTS.DISCOUNT_CONFIGURATION'
            )}
            fallbackPath="/customer-discounts"
          >
            <CustomerDiscountPage />
          </GuardedPageRoute>
        }
      />
      <Route path="*" element={<ErrorPage />} />
    </Routes>
  );
};

// const ServerListRoutes = () => {
//   const { t } = useTranslation();
//
//   return (
//     <Routes>
//       <Route
//         index
//         element={
//           <PathBasedPermissionRoute fallbackPath="/">
//             <ProtectedRoute pageName={t('STAFF_SIDEBAR.SERVER_LIST')}>
//               <ServerListPage />
//             </ProtectedRoute>
//           </PathBasedPermissionRoute>
//         }
//       />
//       <Route
//         path="create"
//         element={
//           <PathBasedPermissionRoute fallbackPath="/" action="create">
//             <ProtectedRoute
//               pageName={t('SERVER_LIST.CREATE_EDIT.CREATE_TITLE')}
//             >
//               <ServerListCreatePage />
//             </ProtectedRoute>
//           </PathBasedPermissionRoute>
//         }
//       />
//       <Route
//         path="edit/:id"
//         element={
//           <PathBasedPermissionRoute fallbackPath="/" action="update">
//             <ProtectedRoute pageName={t('SERVER_LIST.CREATE_EDIT.EDIT_TITLE')}>
//               <ServerListEditPage />
//             </ProtectedRoute>
//           </PathBasedPermissionRoute>
//         }
//       />
//     </Routes>
//   );
// };
